import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { UserDataChangesListState, UserDataChangesStateModel } from './user-data-changes-list.state';
import { SetInitialStateFacade } from '../../../../../common/models';
import { UserDataChangesListInitialState, UserDataChangesListLoad } from './user-data-changes-list.actions';
import { UserDataChangesModel } from '../models/user-data-changes.model';

@Injectable({ providedIn: 'root' })
export class UserDataChangesListFacade implements SetInitialStateFacade {
  listDto$: Observable<UserDataChangesStateModel> = this.store.select(UserDataChangesListState.getState);
  items$: Observable<UserDataChangesModel[]> = this.store.select(UserDataChangesListState.getItems);

  constructor(private store: Store) {}

  loadAll(email: string): void {
    this.store.dispatch(new UserDataChangesListLoad({ email }));
  }

  setInitialState(): void {
    this.store.dispatch(new UserDataChangesListInitialState());
  }
}
